import { render, staticRenderFns } from "./ContactCategory.vue?vue&type=template&id=6403bc5a&scoped=true&"
import script from "./ContactCategory.vue?vue&type=script&lang=js&"
export * from "./ContactCategory.vue?vue&type=script&lang=js&"
import style0 from "./ContactCategory.vue?vue&type=style&index=0&id=6403bc5a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403bc5a",
  null
  
)

export default component.exports